const isJSON = (value?: string) => value && /(:{")+|({")+/g.test(value) && value.startsWith('{"');

export default isJSON;
